import { useEffect } from "react";

const SITE_NAME = "Jiggly";
const DEFAULT_TITLE = "Jiggly — Keep Your Status Active | Free Online Mouse Jiggler";
const DEFAULT_DESC =
  "Free browser-based mouse jiggler that keeps your screen awake and your Microsoft Teams, Slack & Zoom status green. Zero installation, zero admin rights, 100% safe.";
const DEFAULT_IMAGE =
  `${process.env.REACT_APP_SITE_URL}/images/jiggly-social-preview.jpg`;

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export default function SEO({ title, description, image, path }) {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const img = image || DEFAULT_IMAGE;
    setMeta("name", "description", desc);
    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("property", "og:title", title || DEFAULT_TITLE);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:image", img);
    setMeta("property", "og:url", window.location.href);
    setMeta("name", "twitter:title", title || DEFAULT_TITLE);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", img);
  }, [title, description, image, path]);

  return null;
}
